import { CrudFilter, CrudOperators } from '@pankod/refine-core';

export function buildFilterItem<T = any>(
  field: string,
  operator: CrudOperators,
  value: T
): CrudFilter {
  let filterValue: string | T =
    typeof value === 'string' ? (value.trim() as unknown as T) : value;

  switch (operator) {
    case 'contains':
      if (filterValue) {
        // Filter records whose field value contains filter value
        filterValue = `%${filterValue}%` as unknown as T;
      }
      break;

    default:
      break;
  }
  return {
    field,
    operator,
    value: filterValue || null
  } as CrudFilter;
}
